// extracted by mini-css-extract-plugin
export default {"locationGroup":"_2RNfe","tanakLocationGroup":"_3yhKe","locationGroupLevel0":"Mtq78"};